function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_587",
  "data-name": "Grupo 587",
  transform: "translate(-98.755 -120.381)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_585",
  "data-name": "Grupo 585",
  transform: "translate(102.758 120.381)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_883",
  "data-name": "Caminho 883",
  d: "M108.037,132.849a6.234,6.234,0,1,1,6.235-6.235A6.241,6.241,0,0,1,108.037,132.849Zm0-11.206a4.972,4.972,0,1,0,4.973,4.971A4.977,4.977,0,0,0,108.037,121.643Z",
  transform: "translate(-101.804 -120.381)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_586",
  "data-name": "Grupo 586",
  transform: "translate(98.755 134.068)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_884",
  "data-name": "Caminho 884",
  d: "M119.755,138.673h-21v-.631c0-4.189,3.317-7.727,7.242-7.727h6.517c3.925,0,7.241,3.538,7.241,7.727Zm-19.732-1.262h18.465a6.288,6.288,0,0,0-5.974-5.834H106A6.287,6.287,0,0,0,100.023,137.411Z",
  transform: "translate(-98.755 -130.315)"
})));

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22.045,
    viewBox: "0 0 21 22.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b9eb8b81.svg";
export { ForwardRef as ReactComponent };